import { UseMutationOptions, useMutation, useQueryClient } from 'react-query';
import { UpdateContractEndDateRequestPayload } from '../../../../../libs/api-definition/src/api-definition-paths/contract-paths/update-contract-end-date-path/update-contract-end-date-request-schema';
import { getPrivateApi } from '../../services/api';
import { vyDate } from '@vy/date';
import {
  invalidateContractsQueries,
  invalidateCustomersQueries,
  invalidateBillingRevenueQueries,
} from '../../utils/query-invalidation';

export function useExtendContract(
  contractId: string,
  options?: UseMutationOptions<void, unknown, UpdateContractEndDateRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['extend-contract'],
    ({ endDate }) => {
      const api = getPrivateApi();
      const normalizedEndDate = normalizeContractEndDateToUtcEndOfDay(endDate);

      return api.updateContractEndDate({ contractId, updateContractEndDateRequest: { endDate: normalizedEndDate } });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(contractId),
          }),
          invalidateContractsQueries(queryClient),
          invalidateCustomersQueries(queryClient),
          invalidateBillingRevenueQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}


function normalizeContractEndDateToUtcEndOfDay(endDate: Date): Date {
  return vyDate(endDate).endOf('day').toDate();
}
